// Read-only "view as client" impersonation, scoped to ONE browser tab.
//
// Flow: the manager clicks "Кабінет клієнта" → backend mints a short-lived,
// read-only client session token → we open the portal in a new tab with the
// token in the URL hash (#imptoken=...). On boot we move it into sessionStorage
// (which is PER-TAB), so the manager's normal localStorage login in their other
// tabs is never touched. Every request in this tab then uses the impersonation
// token, and the backend's readonly_impersonation_guard blocks any writes.

const IMP_TOKEN = "imp_token";
const IMP_ACTIVE = "imp_active";

export function bootstrapImpersonation() {
  try {
    const m = (window.location.hash || "").match(/imptoken=([^&]+)/);
    if (m) {
      sessionStorage.setItem(IMP_TOKEN, decodeURIComponent(m[1]));
      sessionStorage.setItem(IMP_ACTIVE, "1");
      // Strip the token from the URL so it doesn't linger in history/screenshots.
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  } catch (_) {
    /* sessionStorage may be unavailable (private mode edge cases) — ignore */
  }
}

export function isImpersonating() {
  try {
    return !!sessionStorage.getItem(IMP_ACTIVE);
  } catch (_) {
    return false;
  }
}

// Token used for every request in this tab: impersonation token wins, else the
// manager's own localStorage login.
export function getAuthToken() {
  try {
    const imp = sessionStorage.getItem(IMP_TOKEN);
    if (imp) return imp;
  } catch (_) {
    /* ignore */
  }
  return localStorage.getItem("token");
}

export function exitImpersonation() {
  try {
    sessionStorage.removeItem(IMP_TOKEN);
    sessionStorage.removeItem(IMP_ACTIVE);
  } catch (_) {
    /* ignore */
  }
}

// Run immediately on import so the very first auth/request in this tab already
// uses the impersonation token.
bootstrapImpersonation();
